import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=9b792ac0&scoped=true&"
import script from "./index copy.vue?vue&type=script&lang=js&"
export * from "./index copy.vue?vue&type=script&lang=js&"
import style0 from "./index copy.vue?vue&type=style&index=0&id=9b792ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b792ac0",
  null
  
)

export default component.exports